import { render, staticRenderFns } from "./LinkDataSidebar.vue?vue&type=template&id=92614850&scoped=true&"
import script from "./LinkDataSidebar.vue?vue&type=script&lang=js&"
export * from "./LinkDataSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LinkDataSidebar.vue?vue&type=style&index=0&id=92614850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92614850",
  null
  
)

export default component.exports